// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1SZOI","selected":"Chip_selected__OG80Z"};